<div class="sticky-top mat-elevation-z6">
    <mat-toolbar class="trip-header-bar bds-toolbar-blue">
        <mat-toolbar-row>
            <span>
                <fa-icon [icon]="iconTrain" [fixedWidth]="true" size="lg"></fa-icon>
                {{ ormIds.length }} <span>Interface Validation(s) Selected</span>
                <span *ngIf="isDirty">*</span>
                <span *ngIf="isSaving">
                    <small>
                        (Processing...
                        <ng-container *ngIf="progressTotal > 0">
                            {{ progressDone }} / {{ progressTotal }} </ng-container
                        >)
                        <fa-icon [icon]="iconSpinner" class="spinning"></fa-icon>
                    </small>
                </span>
            </span>
            <span class="fill-remaining-space"></span>
            <span>
                <button
                    mat-stroked-button
                    (click)="addImports()"
                    [disabled]="isSaving || isChangesNotSaved"
                >
                    <fa-icon [icon]="import"></fa-icon> Add Imports
                </button>
                <button
                    mat-stroked-button
                    (click)="reProcess()"
                    [disabled]="isSaving || isChangesNotSaved"
                >
                    <fa-icon [icon]="reprocess"></fa-icon> Re Process
                </button>
                <button
                    mat-stroked-button
                    (click)="update()"
                    [disabled]="isSaving || !isChangesNotSaved"
                >
                    <fa-icon [icon]="save"></fa-icon> Update Interface Validations
                </button>
                <rt-trip-error-more-options
                    [trip]="selectedTripError"
                    [isMultiTripError]="true"
                ></rt-trip-error-more-options>
            </span>
        </mat-toolbar-row>
    </mat-toolbar>
    <div class="container-fluid jump-nav">
        <mat-chip-listbox>
            <mat-chip-option
                bdsScrollSpyLink="tripErrorGrid"
                color="accent"
                [selectable]="false"
                [highlighted]="(scrollSpyService.currentSection | async) === 'tripErrorGrid'"
                (click)="setCurrentSection('tripErrorGrid')"
            >
                <span>Interface Validations Grid</span>
            </mat-chip-option>
            <mat-chip-option
                bdsScrollSpyLink="tripErrorDetailsAnchor"
                color="accent"
                [selectable]="false"
                [highlighted]="
                    (scrollSpyService.currentSection | async) === 'tripErrorDetailsAnchor'
                "
                (click)="setCurrentSection('tripErrorDetailsAnchor')"
            >
                <span>Interface Detail</span>
            </mat-chip-option>
        </mat-chip-listbox>
    </div>
</div>
<mat-sidenav-container>
    <mat-sidenav
        mode="side"
        position="end"
        class="mat-elevation-z4 pt-3 side-nav"
        #tripSidenav
        [opened]="true"
    >
        <div class="side-nav-class" *ngFor="let trip of selectedTrips">
            <span>
                <ng-container [ngSwitch]="trip.state">
                    <fa-icon
                        [icon]="iconStatusSaved"
                        [fixedWidth]="true"
                        *ngSwitchCase="'saved'"
                        class="state-saved"
                    ></fa-icon>
                    <fa-icon
                        [icon]="iconStatusSaving"
                        [fixedWidth]="true"
                        *ngSwitchCase="'saving'"
                        class="state-saving spinning"
                    ></fa-icon>
                    <fa-icon
                        [icon]="iconStatusFailed"
                        [fixedWidth]="true"
                        *ngSwitchCase="'failed'"
                        class="state-failed"
                    ></fa-icon>
                    <fa-icon
                        [icon]="iconStatusNone"
                        [fixedWidth]="true"
                        *ngSwitchDefault
                        class="state-none"
                    ></fa-icon>
                </ng-container>
                <span
                    [matTooltip]="getTripErrorTooltip(trip)"
                    [matTooltipDisabled]="trip.state !== 'failed' || !trip.errors?.length"
                    matTooltipClass="trip-error-tooltip"
                    matTooltipPosition="right"
                    [class.trip-has-errors]="trip.state === 'failed' && !!trip.errors?.length"
                    >{{ trip.key.carInit }}{{ trip.key.carNo }}</span
                >
            </span>
        </div>
    </mat-sidenav>
    <div class="pt-3">
        <!-- Trip Details-->
        <div bdsScrollSpySection="tripErrorGrid" [scrollMargin]="116" #tripErrorGrid>
            @if (loading) {
            <div>Loading...</div>
            } @else {
            <rt-trip-error-details
                #tripErrorDetails
                [tripError]="selectedTripError"
                [tripErrorOrmIds]="ormIds"
                [highlightDirty]="true"
                (notifyToUpdateTrip)="reProcess()"
                [allowPopout]="allowPopout"
                [multipleTrips]="true"
                (formDirtyChange)="onFormDirtyChange($event)"
            >
            </rt-trip-error-details>
            }
        </div>
    </div>
</mat-sidenav-container>

<div style="padding-bottom: 500px"></div>
